/**
 * Aviso de atalho sem fluxo — C-88.
 *
 * O atalho "Abrir fluxo TARP" (dashboard, tabelas técnicas, mapa) navegava para cá sem
 * state quando não conseguia montar o fluxo, e o usuário caía na lista em silêncio. Agora
 * ele traz o motivo (`readAtalhoSemFluxo`) e esta faixa o diz, apontando os acionamentos
 * manuais. Só apresentação: a frase vem pronta de `mensagemSemFluxo` (domínio).
 */
interface Props {
  mensagem: string;
  onFechar: () => void;
}

export default function AvisoSemFluxo({ mensagem, onFechar }: Props) {
  return (
    <div
      role="alert"
      className="mb-3 flex items-start gap-3 rounded-lg border border-level-atencao/60 bg-level-atencao/10 px-4 py-3 text-sm text-white"
    >
      <span aria-hidden className="text-level-atencao">⚠</span>
      <p className="min-w-0 flex-1 leading-snug">{mensagem}</p>
      <button
        type="button"
        onClick={onFechar}
        aria-label="Fechar aviso"
        className="shrink-0 rounded px-2 text-jf-muted hover:text-white"
      >
        ✕
      </button>
    </div>
  );
}
